import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Head = ({ config }) => (
  <thead>
    <tr>
      <th className={classNames('p-l', {
        'languages-table__header-handle': config?.access?.languages_edit_position,
      })}
      >
        Name
      </th>
      <th>Visibility</th>
      <th>Last modified</th>
      {config?.access?.languages_translations_list
        ? <th>{' '}</th> : null}
    </tr>
  </thead>
);

Head.propTypes = {
  config: PropTypes.object,
};

export default Head;
